import { Redirect } from "next";

import { FormattedApiError } from "./formatAndReturnRejectedError";

export type RedirectHint = {
  slugChangedTo: string;
  urlChangedTo: string;
};

export const SLUG_HEADER = "x-slug-changed-to";
export const URL_HEADER = "x-url-changed-to";

export const tryParseRedirectHint = (
  e: FormattedApiError,
): RedirectHint | null => {
  const headers = e.error?.response?.headers;
  if (headers && SLUG_HEADER in headers && URL_HEADER in headers) {
    const { [SLUG_HEADER]: slugChangedTo, [URL_HEADER]: urlChangedTo } =
      headers;
    return { slugChangedTo, urlChangedTo };
  }
  return null;
};

export const isRedirectHint = (v: unknown): v is RedirectHint =>
  typeof v !== "object" || v === null
    ? false
    : "slugChangedTo" in v && "urlChangedTo" in v;

export const throwOnRedirectHint = async <T>(
  retrieve: () => Promise<T | RedirectHint>,
  slug: string,
): Promise<T> => {
  const result = await retrieve();
  if (isRedirectHint(result)) {
    throw new RedirectHintReceivedError(slug, result.slugChangedTo);
  }
  return result;
};

export class RedirectHintReceivedError extends Error {
  public oldSlug: string;
  public newSlug: string;

  constructor(oldSlug: string, newSlug: string) {
    super();
    this.oldSlug = oldSlug;
    this.newSlug = newSlug;
  }

  public buildRedirect = (url: string): Redirect => ({
    destination: url.replace(this.oldSlug, this.newSlug),
    permanent: true,
  });
}
